export default "__VITE_ASSET__BeM9AGCY__"